import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import BaseTextField from '@/components/base_text_field/Index.vue';
import ActionButton from '@/components/action_button/Index.vue';
import DateMixin from '@/helpers/mixins/DateMixin';
import { SHORTDATE_FORMAT } from '../../helpers/constants/app';
/**
 * Base DatePicker Field
 * @author Charles Martinez
 * @since v0.0.2
 */
let DatePickerIndex = class DatePickerIndex extends mixins(DateMixin) {
    constructor() {
        super(...arguments);
        this.openDateModal = false;
        this.date = '';
        this.dateTime = '';
    }
    closePicker() {
        this.openDateModal = false;
    }
    created() {
        if (this.presetDate) {
            const { presetDate } = this;
            this.date = this.formatDate(SHORTDATE_FORMAT, presetDate);
        }
    }
};
__decorate([
    Prop({ type: String, default: '' })
], DatePickerIndex.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DatePickerIndex.prototype, "closeOnContentClick", void 0);
__decorate([
    Prop({ type: String, default: 'Pick a Date' })
], DatePickerIndex.prototype, "labelTitle", void 0);
__decorate([
    Prop({ type: String, default: 'Select Date Here' })
], DatePickerIndex.prototype, "fieldPlaceHolder", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], DatePickerIndex.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DatePickerIndex.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String })
], DatePickerIndex.prototype, "presetDate", void 0);
__decorate([
    Prop({ type: String })
], DatePickerIndex.prototype, "minDate", void 0);
DatePickerIndex = __decorate([
    Component({
        components: {
            BaseTextField,
            ActionButton,
        },
    })
], DatePickerIndex);
export default DatePickerIndex;
